module.exports = __webpack_public_path__ + "assets/ivc-analyze-driving.7a942c79.svg";